import { recognizeRpcDefinition } from "@redotech/redo-recognize-rpc/definition";
import type { InferRpcDefinition } from "@redotech/rpc/definition";
import {
  getCustomerAgentThread,
  getCustomerAgentThreads,
} from "./schema/customer-agent/get-customer-agent-threads";
import { messageCustomerAgent } from "./schema/customer-agent/message-customer-agent";
import { getCustomerById } from "./schema/customers/get-customer-by-id";
import { getCustomers } from "./schema/customers/get-customers";
import { getCustomersByEventData } from "./schema/customers/get-customers-by-event-data";
import { getCustomersCount } from "./schema/customers/get-customers-count";
import { getVanguardPreviewCustomers } from "./schema/customers/get-vanguard-preview-customers";

export const rpcDefinition = {
  // customers
  getCustomers,
  getCustomerById,
  getCustomersByEventData,
  getCustomersCount,
  getVanguardPreviewCustomers,

  // customer agent
  getCustomerAgentThread,
  getCustomerAgentThreads,
  messageCustomerAgent,

  // recognize
  ...recognizeRpcDefinition,
};

export type RedoCustomerRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
